export enum ColsNamesEnum {
    title = 'title',
    total = 'total',
    traveller = "traveller",
}